import React from "react";

export const DocumentUploadModal = ({onClose, textDocumentType, onFilesUpload}) => {

  const handleFileUpload = (event) => {
    onFilesUpload(event.target.files);
  }

  return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
            <div className="flex justify-between items-center p-4 border-b">
              <h3 className="text-lg font-semibold">
                Dokument hochladen: {textDocumentType}
              </h3>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 text-xl"
              >
                ×
              </button>
            </div>
            <div className="p-4 space-y-4">
              <p className="text-sm text-gray-600">
                Wählen Sie eine Datei aus (max. 5 MB)
              </p>
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                onChange={handleFileUpload}
                className="w-full p-2 border border-gray-300 rounded"
              />
              <div className="flex justify-end space-x-2">
                <button
                  onClick={onClose}
                  className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                >
                  Abbrechen
                </button>
              </div>
            </div>
          </div>
        </div>
  );
}